import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { COLORS } from 'config/theme/baseTheme';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    documentVerificationBadge: {
      alignItems: 'center',
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(1, 1.5),
      margin: theme.spacing(1.5, 0, 1.5, 0),
      width: 'auto',
      '& .icon': {
        width: 16,
        height: 16,
        marginRight: theme.spacing(1),
      },
      '& .label': {
        fontSize: 13,
        fontWeight: 600,
      },
      '&.PENDING': {
        backgroundColor: COLORS.FFFBEB,
        '& .label': {
          color: COLORS.BG92400E,
        },
        '& .icon': {
          color: COLORS.BG92400E,
        },
      },
      '&.SUCCESS': {
        backgroundColor: COLORS.F0FDF4,
        '& .label': {
          color: COLORS.BG008732,
        },
        '& .icon': {
          color: COLORS.BG008732,
        },
      },
      '&.FAILED': {
        backgroundColor: COLORS.FBEFF2,
        '& .label': {
          color: COLORS.E11D20,
        },
        '& .icon': {
          color: COLORS.E11D20,
        },
      },
    },
  })
);
